var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from './component';
export { ComponentInstances } from "./component";
import * as querystring from 'querystring';
var EmptyGuid = "00000000-0000-0000-0000-000000000000";
var PageOption = /** @class */ (function () {
    function PageOption(routeData, idx) {
        //let path = params.controller + "/" + (params.action == "create" ? "edit" : params.action);
        this.domId = "page_id_" + idx;
        this.routeData = routeData;
        // this.animate = routeData.["animate"]
    }
    return PageOption;
}());
export { PageOption };
var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page(html) {
        var _this = _super.call(this, undefined, html) || this;
        _this.hasLayout = true;
        return _this;
    }
    Page.prototype.createNewInstance = function (options) {
        options = Object.assign(options || {}, this.options);
        var staticReference = this.constructor;
        this.options = options;
        this.container = staticReference.template;
        return this;
    };
    return Page;
}(Component));
export { Page };
var RouteData = /** @class */ (function () {
    function RouteData(ctx) {
        var result = querystring.parse(ctx.querystring);
        this.controller = ctx.params.controller;
        this.action = ctx.params.action;
        this.id = ctx.params.id || EmptyGuid;
        this.query = result;
        this.querystring = ctx.querystring;
        this.routeKey = this.controller + "/" + this.action; // ctx.path
    }
    RouteData.prototype.isValid = function () {
        return !("var" == this.controller || "www" == this.action);
    };
    RouteData.prototype.equals = function (routeData) {
        return this.controller == routeData.controller
            && this.action == routeData.action
            && this.id == routeData.id
            && this.querystring == routeData.querystring;
    };
    return RouteData;
}());
export { RouteData };
